<template>
  <div class="modal-window">
    <!-- <button type="button" @click="$emit('close')" class="button button--close">
      <IconClose class="icon icon--medium-large" />
    </button> -->
    <form>
      <div class="layout--text-left modal-window__wrap">
        <Legend class="modal-window__title">Session Expiring</Legend>
        <p class="layout--margin-bottom-lg">
          You have left this browser idle and will automatically be logged out
          in {{ timerSeconds }} seconds
        </p>
        <div class="layout--flex-space-between layout--margin-top-sm">
          <button type="button" class="button" @click="stayLoggedIn">
            Stay Logged In
          </button>
          <button
            type="button"
            class="button button--secondary"
            @click="logUserOut"
          >
            Log Out
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "timeoutModal",
  props: {
    timeToExpire: Number,
    mainTimer: Number,
  },
  data() {
    return {
      timer: 0,
    };
  },
  mounted() {
    this.timer = this.timeToExpire;
    let timerId = setInterval(() => {
      this.timer = this.timer - 1000;
      if (this.timer < 1) {
        clearInterval(timerId);
        this.logOut();
      }
    }, 1000);
  },
  computed: {
    timerSeconds: function() {
      return Math.floor(this.timer / 1000);
    },
  },
  methods: {
    ...mapActions("session", ["logOut", "getNewToken"]),
    stayLoggedIn: function() {
      clearInterval(this.mainTimer);
      this.getNewToken().then(() => this.$emit("close"));
    },
    logUserOut: function() {
      clearInterval(mainTimer);
      this.logOut().then(() => this.$emit("close"));
    },
  },
};
</script>

<style lang="scss">
@import "../styles/components/_modal.scss";
</style>
